import * as React from 'react';

import type {TimelineEntryIconVariant} from 'shells/timeline/gutter/types';

import type {EventFragmentSparse_payload_Quote_lead as Lead} from 'nutshell-graphql-types';

import type {EventForTimeline} from '../types';

import {getQuoteLinkText, getTargetEntities, makeTargetEntitiesDisplay} from './helpers';
import {TimelineBanner} from './timeline-banner';

type Props = {
    event: EventForTimeline;
};

export function TimelineBannerDocumentView(props: Props) {
    const {event} = props;
    const {payload} = event;

    if (payload.__typename !== 'DocumentView') {
        return <></>;
    }

    const contract = payload.contract;
    const salesDocument = payload.salesDocument;

    let iconVariant: TimelineEntryIconVariant;
    let documentTypeLabel: string;
    let htmlUrlPath: string;
    let displayNumber: string;
    let lead: Lead;

    if (contract) {
        iconVariant = 'document';
        documentTypeLabel = 'document';
        htmlUrlPath = contract.htmlUrlPath;
        displayNumber = contract.displayNumber;
        lead = contract.lead;
    } else if (salesDocument) {
        iconVariant = salesDocument.__typename === 'Quote' ? 'quote' : 'invoice';
        documentTypeLabel = salesDocument.__typename.toLowerCase();
        htmlUrlPath = salesDocument.htmlUrlPath;
        displayNumber = salesDocument.displayNumber;
        lead = salesDocument.lead;
    } else {
        return <></>;
    }

    const targetEntities = getTargetEntities(lead);

    const targetEntitiesDisplay = makeTargetEntitiesDisplay(
        targetEntities,
        lead.name,
        lead.htmlUrl
    );

    const documentNumberBold = getQuoteLinkText(htmlUrlPath, displayNumber);

    const action = (
        <span>
            <b>{targetEntitiesDisplay}</b> viewed {documentTypeLabel} {documentNumberBold}
        </span>
    );

    return (
        <TimelineBanner
            id={event.id}
            iconVariant={iconVariant}
            timestamp={event.changeTime}
            actor={null}
            action={action}
            omitActor={true}
        />
    );
}
